import React from 'react'

export default function Illustration () {
  return (
    <div>
      Illustration
    </div>
  )
}
